<template>
  <section>
    <h1 class="text-h3 mb-8">
      Checkboxes
    </h1>
    <v-sheet
      class="mb-4 px-6 py-4"
      outlined
      rounded
    >
      <v-checkbox
        v-model="selected"
        class="mt-0"
        label="Checkbox: on"
        value="checkbox-on"
        hint="A hint for the checkbox."
        persistent-hint
        multiple
      />
      <v-checkbox
        v-model="selected"
        label="Checkbox: off"
        value="checkbox-off"
        hint="A hint for the checkbox."
        persistent-hint
        multiple
      />
      <v-checkbox
        v-model="selected"
        label="Checkbox: indeterminate"
        value="checkbox-indeterminate"
        hint="A hint for the checkbox."
        persistent-hint
        indeterminate
        multiple
      />
      <v-checkbox
        v-model="selected"
        label="Checkbox: on (disabled)"
        value="checkbox-on"
        hint="A hint for the checkbox."
        persistent-hint
        disabled
        multiple
      />
      <v-checkbox
        v-model="selected"
        label="Checkbox: off (disabled)"
        value="checkbox-off"
        hint="A hint for the checkbox."
        persistent-hint
        disabled
        multiple
      />
      <v-checkbox
        v-model="selected"
        label="Checkbox: indeterminate (disabled)"
        value="checkbox-indeterminate"
        hint="A hint for the checkbox."
        persistent-hint
        indeterminate
        disabled
        multiple
      />
    </v-sheet>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/components/checkboxes/">
      <strong>Checkboxes</strong>
    </external-link>
  </section>
</template>

<script>
export default {
  name: 'FormCheckboxes',
  data: () => ({
    selected: ['checkbox-on']
  })
}
</script>
